(() => {

  /* =========================================
     YOUTUBE VIDEO
  ========================================= */

  document
    .querySelectorAll('[data-hc-recipe-video]')
    .forEach(video => {

      const playButton =
        video.querySelector('[data-hc-recipe-play]');

      if (!playButton) return;

      playButton.addEventListener('click', () => {

        const videoId =
          video.dataset.youtubeId;

        if (!videoId) return;

        const iframe =
          document.createElement('iframe');

        iframe.src =
          'https://www.youtube.com/embed/' +
          encodeURIComponent(videoId) +
          '?autoplay=1&playsinline=1&rel=0';

        iframe.title = 'Recipe video';

        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        );

        iframe.setAttribute(
          'allowfullscreen',
          ''
        );

        iframe.setAttribute(
          'playsinline',
          ''
        );

        video.innerHTML = '';
        video.appendChild(iframe);

        iframe.focus();

      });

    });


  /* =========================================
     SHARE
  ========================================= */

  document
    .querySelectorAll('[data-hc-recipe-share]')
    .forEach(button => {

      button.addEventListener('click', async () => {

        const shareData = {
          title: document.title,
          url: window.location.href
        };

        if (navigator.share) {

          try {
            await navigator.share(shareData);
          } catch (error) {
            /* User cancelled share */
          }

          return;

        }

        try {

          await navigator.clipboard.writeText(
            window.location.href
          );

          const originalLabel =
            button.getAttribute('aria-label');

          button.setAttribute(
            'aria-label',
            'Recipe link copied'
          );

          setTimeout(() => {

            button.setAttribute(
              'aria-label',
              originalLabel
            );

          }, 2000);

        } catch (error) {
          /* Clipboard unavailable */
        }

      });

    });


  /* =========================================
     RECIPE BODY
  ========================================= */

  const recipeBodies =
    document.querySelectorAll(
      '[data-hc-recipe-body]'
    );


  /* =========================================
     INGREDIENT UNITS
  ========================================= */

  recipeBodies.forEach(recipeBody => {

    const hasImperial =
      recipeBody.dataset.hasImperial === 'true';

    const hasMetric =
      recipeBody.dataset.hasMetric === 'true';

    const unitButtons =
      recipeBody.querySelectorAll(
        '[data-hc-unit]'
      );

    const ingredientPanels =
      recipeBody.querySelectorAll(
        '[data-hc-ingredients]'
      );


    const setUnits = unit => {

      if (
        unit === 'metric' &&
        !hasMetric
      ) {
        unit = 'imperial';
      }

      if (
        unit === 'imperial' &&
        !hasImperial
      ) {
        unit = 'metric';
      }


      unitButtons.forEach(button => {

        const isActive =
          button.dataset.hcUnit === unit;

        button.classList.toggle(
          'is-active',
          isActive
        );

        button.setAttribute(
          'aria-pressed',
          isActive ? 'true' : 'false'
        );

      });


      ingredientPanels.forEach(panel => {

        panel.hidden =
          panel.dataset.hcIngredients !== unit;

      });

    };


    /* Always default to Imperial on page load */

    setUnits(
      hasImperial
        ? 'imperial'
        : 'metric'
    );


    unitButtons.forEach(button => {

      button.addEventListener(
        'click',
        () => {

          setUnits(
            button.dataset.hcUnit
          );

        }
      );

    });

  });


  /* =========================================
     ADD RECOMMENDED PRODUCT
  ========================================= */

  document
    .querySelectorAll('[data-hc-product-add]')
    .forEach(button => {

      button.addEventListener(
        'click',
        async () => {

          const variantId =
            button.dataset.variantId;

          if (!variantId) return;

          const originalText =
            button.textContent.trim();

          button.classList.add(
            'is-loading'
          );

          button.disabled = true;
          button.textContent = 'Adding';


          try {

            const response =
              await fetch(
                window.Shopify.routes.root +
                'cart/add.js',
                {
                  method: 'POST',

                  headers: {
                    'Content-Type':
                      'application/json',
                    'Accept':
                      'application/json'
                  },

                  body: JSON.stringify({
                    items: [
                      {
                        id: Number(variantId),
                        quantity: 1
                      }
                    ]
                  })
                }
              );


            if (!response.ok) {
              throw new Error(
                'Unable to add product'
              );
            }


            button.classList.remove(
              'is-loading'
            );

            button.classList.add(
              'is-added'
            );

            button.textContent = 'Added';


            document.documentElement
              .dispatchEvent(
                new CustomEvent(
                  'cart:refresh',
                  {
                    bubbles: true
                  }
                )
              );


            setTimeout(() => {

              button.classList.remove(
                'is-added'
              );

              button.disabled = false;
              button.textContent =
                originalText;

            }, 1800);


          } catch (error) {

            button.classList.remove(
              'is-loading'
            );

            button.disabled = false;
            button.textContent =
              'Try Again';


            setTimeout(() => {

              button.textContent =
                originalText;

            }, 1800);

          }

        }
      );

    });


  /* =========================================
     COOK MODE / SCREEN WAKE LOCK
  ========================================= */

  const cookModeToggle =
    document.querySelector(
      '[data-hc-cook-mode]'
    );

  if (!cookModeToggle) return;


  let wakeLock = null;
  let cookModeEnabled = true;


  const updateCookModeToggle = () => {

    cookModeToggle.checked =
      cookModeEnabled;

  };


  const requestWakeLock = async () => {

    if (
      !cookModeEnabled ||
      !('wakeLock' in navigator)
    ) {
      return;
    }


    try {

      wakeLock =
        await navigator.wakeLock.request(
          'screen'
        );


      wakeLock.addEventListener(
        'release',
        () => {
          wakeLock = null;
        }
      );

    } catch (error) {

      wakeLock = null;

    }

  };


  const releaseWakeLock = async () => {

    if (!wakeLock) return;


    try {
      await wakeLock.release();
    } catch (error) {}


    wakeLock = null;

  };


  cookModeToggle.addEventListener(
    'change',
    async () => {

      cookModeEnabled =
        cookModeToggle.checked;


      if (cookModeEnabled) {

        await requestWakeLock();

      } else {

        await releaseWakeLock();

      }

    }
  );


  document.addEventListener(
    'visibilitychange',
    async () => {

      if (
        document.visibilityState === 'visible' &&
        cookModeEnabled &&
        !wakeLock
      ) {

        await requestWakeLock();

      }

    }
  );


  /*
    Try immediately. Some browsers require
    user interaction before granting Wake Lock,
    so we retry on the visitor's first interaction.
  */

  requestWakeLock();


  const retryWakeLock = async () => {

    if (
      cookModeEnabled &&
      !wakeLock
    ) {

      await requestWakeLock();

    }

  };


  document.addEventListener(
    'pointerdown',
    retryWakeLock,
    { once: true }
  );

  document.addEventListener(
    'keydown',
    retryWakeLock,
    { once: true }
  );


  /*
    Hide Cook Mode entirely when the
    Screen Wake Lock API isn't supported.
  */

  if (!('wakeLock' in navigator)) {

    cookModeEnabled = false;

    updateCookModeToggle();

    cookModeToggle.disabled = true;

    const cookMode =
      cookModeToggle.closest(
        '.hc-recipe-cook-mode'
      );

    if (cookMode) {
      cookMode.style.display = 'none';
    }

  }

})();